import "./index.scss";
import HomeMap from "../../assets/img/Homescreen-full-map.png";
import VerticalLine from "../../components/icons/VerticalLine";
import Logo from "../../components/icons/Logo";
import Touch from "../../assets/img/Blue-Touch-Icon.gif";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../context/DataProvider";
const LandingPage = () => { 
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page splash landingPage">
            <div className="home-map" onClick={()=>{
                _logEvent('click', "Main Map", "Business & Industry");
                addFlow("Business & Industry");
                navigate("/business-industry");
            }}>

            </div>
            <div className="logo" onClick={()=>{
                _logEvent('click', "Main Map", "Agilysys");
                addFlow("Agilysys");
                navigate("/aboutus");
            }}><Logo /></div>
            <div className="top-left">
                <div className="topic-header">
                    Maximize Return on Experience{'\n'}
                    <span className="sub-topic-header">
                        For <strong>Business & Industry</strong>
                    </span>
                </div>
                <div className="column">
                    <div className="row"><span>Delight</span> diners</div>
                    <div className="row"><span>Retain</span> staff</div>
                    <div className="row"><span>Grow</span> margins</div>
                    <div className="line"><VerticalLine /></div>
                </div>
            </div>
            
            <div className="bottom-left">
                <img className="touch-prompt" src={Touch} alt=""/>
                <div className="block">
                    Explore our interactive{'\n'}
                    Business & Industry map to discover{'\n'}
                    where <span>personal</span> meets <span>profitable</span>{'\n'}
                    <strong>Touch an area to begin!</strong>
                </div>
                
            </div>
    
        </div>
    )
}
export default LandingPage;